export default __webpack_public_path__ + "static/media/before_home.065673fd.webp";